import React, { useContext, useState, useEffect } from 'react';

import { IsOttContext, MakeFocusableContext } from '../../contexts';

import './TextOttWrapper.css';

const TextOttWrapper = ({ children, pRef, style, settings = {}, }) => {
  const isOtt = useContext(IsOttContext);
  if (!isOtt) {
    return children;
  }

  useContext(MakeFocusableContext)()
  const [showArrows, setShowArrows] = useState(false);
  const [arrowDownFade, setArrowDownFade] = useState(false);
  const [arrowUpFade, setArrowUpFade] = useState(false);

  useEffect(checkHeight);
  useEffect(() => {
    const { current: el } = pRef;
    if (el) {
      setShowArrows(el.scrollHeight > el.clientHeight);
    }
  });

  function checkHeight() {
    const { current: el } = pRef;
    if (el) {
      el.scrollTop === (el.scrollHeight - el.offsetHeight) ? setArrowDownFade(true) : setArrowDownFade(false)
      el.scrollTop === 0 ? setArrowUpFade(true) : setArrowUpFade(false)
    }
  }

  const scroll = (direction) => () => {
    const { current: el } = pRef
    if (el) {
      direction === 'DOWN'
        ? el.scrollTop += (el.scrollHeight * .05)
        : el.scrollTop -= (el.scrollHeight * .05)
      checkHeight()
    }
  }

  return (
    <span className="text-container" style={style}>
      {showArrows && (
        <>
          <button
            tabIndex="1"
            className="focusable scroll-arrow-container up"
            onClick={scroll('UP')}
          >
            <div style={{ borderColor: settings.arrowColor }} className={`scroll-arrow up ${arrowUpFade ? 'fade' : null}`} />
          </button>
          <button
            tabIndex="1"
            className="focusable scroll-arrow-container down"
            onClick={scroll('DOWN')}
          >
            <div style={{ borderColor: settings.arrowColor }} className={`scroll-arrow down ${arrowDownFade ? 'fade' : null}`} />
          </button>
        </>
      )}
      {children}
    </span>
  );
};

export default TextOttWrapper;